import lwBackTopComponent from './lwBackTop'

export const lwBackTopInstall = (Vue) => {
  const Constructor = Vue.extend(lwBackTopComponent);
  Vue.component('lw-back-top', Constructor);
}
